import { LocalizedString } from '@synergy/models';

/**
 * Returns null if the value is empty LocalizedString, empty string, zero, undefined or null, otherwise returns the value.
 * @param value - The value to check for emptiness.
 * @returns The original value or null if it is empty or undefined.
 */
export const nullIfEmpty = <T extends LocalizedString | string | Date | number>(value?: T | null): T | null => {
    if (value === undefined || value === null) {
        return null;
    }

    if (typeof value !== 'object') {
        return value ? value : null;
    }

    return Object.keys(value).length > 0 ? value : null;
};
